import { render, staticRenderFns } from "./ProductSidebar.vue?vue&type=template&id=847ba244"
import script from "./ProductSidebar.vue?vue&type=script&lang=js"
export * from "./ProductSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductSidebar.vue?vue&type=style&index=0&id=847ba244&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports